import { Button } from "@/components/ui/button";
import { FileText, Megaphone, Trash2 } from "lucide-react";

// Whole-round actions, pinned under the round selector: publishing is
// all-or-nothing, and so is clearing. Both keep a fixed position whatever
// else is going on further down the tab.
const RoundActions = ({
  matchupCount,
  draftCount,
  publishedCount,
  queuedCount,
  disabled,
  onPublish,
  onUnpublish,
  onClearAll,
}: {
  matchupCount: number;
  draftCount: number;
  publishedCount: number;
  queuedCount: number;
  disabled: boolean;
  onPublish: () => void;
  onUnpublish: () => void;
  onClearAll: () => void;
}) => {
  if (matchupCount === 0) return null;

  const blockedByQueue = queuedCount > 0;
  const publishDisabled = disabled || blockedByQueue;

  return (
    <div className="space-y-2">
      {/* Nothing to publish or hide once a round has been scored and its
          matchups are `resolved` — but they can still be cleared. */}
      {(draftCount > 0 || publishedCount > 0) && (
        <div className="space-y-1">
          {draftCount > 0 ? (
            <Button className="w-full font-semibold" disabled={publishDisabled} onClick={onPublish}>
              <Megaphone className="mr-1.5 h-4 w-4" />
              Publish all matchups
            </Button>
          ) : (
            <Button
              variant="outline"
              className="w-full font-semibold text-destructive hover:text-destructive"
              disabled={publishDisabled}
              onClick={onUnpublish}
            >
              <FileText className="mr-1.5 h-4 w-4" />
              Remove all published matchups
            </Button>
          )}
          {blockedByQueue && (
            <p className="text-center text-[11px] text-muted-foreground">Apply your queued changes first.</p>
          )}
        </div>
      )}

      <Button
        variant="outline"
        className="w-full font-semibold text-destructive hover:text-destructive"
        disabled={disabled}
        onClick={onClearAll}
      >
        <Trash2 className="mr-1.5 h-4 w-4" />
        Clear all
      </Button>
    </div>
  );
};

export default RoundActions;
